import { SVGProps } from 'react';

const BottleWine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17 13a6 6 0 0 0-1.2-3.6l-.6-.8A6 6 0 0 1 14 5V3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v2a6 6 0 0 1-1.2 3.6l-.6.8A6 6 0 0 0 7 13v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1zm0 0h-4a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h4"
    />
  </svg>
);
export default BottleWine;
